import React, { useState } from 'react';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import { useNavigate } from 'react-router-dom';
import { paths } from '@/app/paths';
import { ClientIcon } from '@/components/icons/Client';
import { ClaimsIcon } from '@/components/icons/ClaimsIcon';
import { IMPORT_TYPES } from './ImportsTable/importTypes';

// Each import type's page; types without one aren't built yet
const IMPORT_PAGES = {
	users: `${paths.admin}/import/users`,
};

// Each import type's icon, as in the side nav (the CRM icons colour their paths only when
// given a color)
const IMPORT_ICONS = {
	users: <GroupOutlinedIcon fontSize='small' />,
	clients: <ClientIcon width='20px' height='20px' bgColor='transparent' color='currentColor' />,
	claims: <ClaimsIcon width='20px' height='20px' bgColor='transparent' color='currentColor' />,
};

/**
 * The import history's Import button: a menu of the import types (Users, Clients, Claims)
 * that opens that type's import page. Types without a page yet are disabled, with
 * "Coming soon".
 */
export const ImportMenuButton = () => {
	const navigate = useNavigate();
	const [anchorEl, setAnchorEl] = useState(null);

	return (
		<>
			<Button
				variant='contained'
				startIcon={<UploadFileIcon />}
				endIcon={<ArrowDropDownIcon />}
				onClick={(event) => setAnchorEl(event.currentTarget)}
			>
				Import
			</Button>
			<Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
				{IMPORT_TYPES.map(({ id, name }) =>
					IMPORT_PAGES[id] ? (
						<MenuItem key={id} onClick={() => navigate(IMPORT_PAGES[id])}>
							<ListItemIcon>{IMPORT_ICONS[id]}</ListItemIcon>
							<ListItemText>{name}</ListItemText>
						</MenuItem>
					) : (
						<Tooltip key={id} title='Coming soon' placement='left'>
							{/* A disabled item gets no pointer events, so the span shows the tooltip */}
							<span>
								<MenuItem disabled>
									<ListItemIcon>{IMPORT_ICONS[id]}</ListItemIcon>
									<ListItemText>{name}</ListItemText>
								</MenuItem>
							</span>
						</Tooltip>
					),
				)}
			</Menu>
		</>
	);
};
